module.exports = __webpack_public_path__ + "img/snowboarding.2e1ccc06.svg";